import { render, staticRenderFns } from "./HistoryCard.vue?vue&type=template&id=6d99f35c"
import script from "./HistoryCard.vue?vue&type=script&lang=js"
export * from "./HistoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports